export const LogoMark = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 64 64" fill="none" className={className} aria-hidden="true">
    <path d="M32 3 57 11v22c0 15.5-10.5 24.5-25 28C17.5 57.5 7 48.5 7 33V11L32 3Z" fill="#0F172A" />
    <path d="M32 7.5 53 14.5V33c0 13-8.8 20.8-21 24-12.2-3.2-21-11-21-24V14.5L32 7.5Z" fill="#2563EB" />
    <path d="M26 47 30 20h4l4 27h-5.4l-1-9h-1.2l-1 9H26Z" fill="#fff" />
    <path d="M31.1 24h1.8l-.3 5h-1.2l-.3-5Z" fill="#2563EB" />
    <path d="M31.2 32h1.6l-.3 6h-1l-.3-6Z" fill="#2563EB" />
    <path d="M31.3 41h1.4l-.3 6h-.8l-.3-6Z" fill="#2563EB" />
  </svg>
);

export const Logo = ({ light = false, className = "" }) => (
  <span className={`inline-flex items-center gap-2.5 ${className}`}>
    <LogoMark className="h-9 w-9" />
    <span className="leading-none">
      <span className={`block font-display text-lg font-bold tracking-tight ${light ? "text-white" : "text-brand-navy"}`}>
        Fleetguard
      </span>
      <span className={`block font-mono text-[9px] uppercase tracking-[0.35em] ${light ? "text-white/60" : "text-brand-blue"}`}>
        Insurance
      </span>
    </span>
  </span>
);
